// Ödeme sağlayıcılarının "Genel" sekmesi form şemaları.
// Alan adları ilgili hook'ların formik initialValues'ı ile birebir eşleşir.
export const PAYMENT_FIELD_SCHEMAS = {
    paytr: {
        infoAlert: {
            icon: "bx-info-circle",
            title: "Bildirim URL Ayarı",
            body: "PayTR panelinizde bildirim URL'sini el ile girmeniz gerekirse aşağıdaki adresi kullanın:",
            code: "https://panel.tahsilat360.com/api/payments/paytr-notify",
        },
        // Uye is yeri basvuru baglantisi. URL'deki hash Tahsilat360'ın PayTR
        // referans (ref) kodu; sabittir, config/env'den gelmez. Entegrasyon
        // ekrani yeniden tasarlanirken (95a4d3d) yanlislikla dusmustu.
        signup: {
            url: "https://www.paytr.com/uye-isyeri-olun/fe6a8bee7dbe28809cef664ddca4bc1f7026d19b1922ced7289c80ce058987c4",
            note: "PayTR üye iş yeri değilseniz başvurunuzu buradan yapabilirsiniz.",
            label: "PayTR Üye İş Yeri Başvurusu",
        },
        fields: [
            { name: "merchantId", label: "Merchant ID (Mağaza No)", placeholder: "Örn: 123456", col: 6 },
            { name: "merchantKey", label: "Merchant Key (Mağaza Parola)", placeholder: "PayTR panelinden alınız", col: 6 },
            { name: "merchantSalt", label: "Merchant Salt (Mağaza Gizli Anahtar)", placeholder: "PayTR panelinden alınız", type: "password", col: 6 },
        ],
        testModeLabel: "Gerçek ödeme almadan önce entegrasyonu test etmek için açınız.",
    },
    param: {
        fields: [
            { name: "clientCode", label: "Müşteri Kodu (Client Code)", placeholder: "Müşteri kodunuz", col: 6, hint: "Müşteri kodunu Param panelinizden alabilirsiniz." },
            { name: "clientUsername", label: "Müşteri Kullanıcı Adı", col: 6 },
            { name: "clientPassword", label: "Müşteri Şifresi", type: "password", col: 6, hint: "Güvenli şekilde şifrelenerek saklanır." },
            { name: "guid", label: "GUID (API Anahtarı)", placeholder: "Size özel GUID anahtarı", col: 6 },
            { name: "allowedIp", label: "İzin Verilen IP (Opsiyonel)", placeholder: "Örn: 127.0.0.1", col: 12 },
        ],
        testModeLabel: "Param test ortamında işlem yapmak için aktif edin.",
    },
    esnekpos: {
        // Basvuru baglantisi; ?ref= parametresi Tahsilat360'ın referans kodu.
        signup: {
            url: "https://pos.esnekpos.com/Onboarding/Register.aspx?ref=a4873727-1f9e-412c-aea3-6e860731735b",
            note: "Hoppa üye iş yeri değilseniz başvurunuzu buradan yapabilirsiniz.",
            label: "Hoppa Üye İş Yeri Başvurusu",
        },
        fields: [
            { name: "merchant", label: "Merchant (Üye İş Yeri No)", placeholder: "Örn: TEST1234", col: 6, hint: "Üye iş yeri numaranızı Hoppa panelinizden alabilirsiniz." },
            { name: "merchantKey", label: "Merchant Key (Üye İş Yeri Anahtarı)", placeholder: "Hoppa panelinden alınız", col: 6, hint: "Güvenli şekilde şifrelenerek saklanır." },
            { name: "merchantPublicToken", label: "Merchant Public Token (Açık Erişim Anahtarı)", placeholder: "Hoppa panelinden alınız", col: 12 },
        ],
        testModeLabel: "Hoppa test ortamında işlem yapmak için aktif edin.",
    },
    qnb_payfor: {
        fields: [
            { name: "merchantId", label: "Merchant ID (Üye İş Yeri No)", placeholder: "QNB panelinden alınız", col: 6, hint: "Merchant ID'yi QNB panelinizden alabilirsiniz." },
            { name: "userCode", label: "Kullanıcı Kodu", col: 6 },
            { name: "userPass", label: "Kullanıcı Şifresi", type: "password", col: 6, hint: "Güvenli şekilde şifrelenerek saklanır." },
            { name: "merchantPass", label: "Merchant Şifresi", type: "password", col: 6, hint: "Güvenli şekilde şifrelenerek saklanır." },
        ],
        testModeLabel: "QNB PayFor test ortamında işlem yapmak için aktif edin.",
    },
    garanti: {
        fields: [
            { name: "merchantId", label: "Merchant ID (Üye İş Yeri No)", placeholder: "Garanti panelinden alınız", col: 6, hint: "Merchant ID'yi Garanti BBVA sanal POS panelinizden alabilirsiniz." },
            { name: "terminalId", label: "Terminal ID (Terminal No)", placeholder: "Örn: 30691297", col: 6, hint: "Terminal numaranızı Garanti panelinden alabilirsiniz." },
            { name: "provUserId", label: "Provizyon Kullanıcısı", placeholder: "PROVAUT", col: 6, hint: "Genellikle PROVAUT olarak gelir." },
            { name: "provisionPassword", label: "Provizyon Şifresi", type: "password", col: 6, hint: "Güvenlik gereği boş gelir, kaydetmek için tekrar girin." },
            { name: "storeKey", label: "Store Key (Mağaza Anahtarı)", type: "password", col: 12, hint: "Güvenlik gereği boş gelir, kaydetmek için tekrar girin." },
        ],
        testModeLabel: "Garanti BBVA test ortamında işlem yapmak için aktif edin.",
    },
    isyerimpos: {
        infoAlert: {
            icon: "bx-info-circle",
            title: "Sonuç Bildirim (ReturnUrl) Ayarı",
            body: "İşyerimPOS panelinizde sonuç bildirim adresini el ile girmeniz gerekirse aşağıdaki adresi kullanın:",
            // Sabit domain yerine panelin açıldığı adres: domain değişince kendiliğinden güncel kalır.
            code: `${window.location.origin}/api/payments/isyerimpos-callback`,
        },
        // Başvuru dış bağlantı değil, bu ekranda açılan formdur (IsyerimPosApplicationForm).
        signup: {
            form: "isyerimpos",
            note: "İşyerimPOS üye iş yeri değilseniz başvurunuzu buradan yapabilirsiniz.",
            label: "İşyerimPOS Üye İş Yeri Başvurusu",
        },
        fields: [
            { name: "merchantId", label: "Merchant ID (İş Yeri No)", placeholder: "İşyerimPOS panelinden alınız", col: 6, hint: "Merchant ID'yi İşyerimPOS panelinizden alabilirsiniz." },
            { name: "userId", label: "API Kullanıcı ID", placeholder: "API kullanıcı ID'niz", col: 6, hint: "API işlem yetkili kullanıcının ID'si." },
            { name: "apiKey", label: "API Anahtarı (ApiKey)", type: "password", col: 12, hint: "Güvenli şekilde şifrelenerek saklanır." },
        ],
        testModeLabel: "İşyerimPOS test ortamında işlem yapmak için aktif edin.",
    },
};
